module.exports = __webpack_public_path__ + "static/media/pearl.c05fda3c.png";